module.exports = __webpack_public_path__ + "media/ko_kr_s4_YooJoon.9fb6d5e1.oga";